import type { File, Folder } from '@efdigital/ll-addon-data';
import { Heading } from '@efdigital/ll-addon-ui';
import FileBrowser from '@efdigital/ll-admin-v2/components/files/file-browser.gts';
import FileUploader from '@efdigital/ll-admin-v2/components/files/file-uploader.gts';
import type { LibraryClientsEditModel } from '@efdigital/ll-admin-v2/routes/library/clients/client';
import { on } from '@ember/modifier';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

interface Signature {
  Args: {
    model: LibraryClientsEditModel;
  };
}

export default class LibraryClientsClientEditFiles extends Component<Signature> {
  @service declare router: RouterService;

  @tracked showUploader = false;
  @tracked currentFolderPath: string = this.clientFolderPath;

  get clientFolderPath() {
    return `|${this.args.model.client.id}`;
  }
  navigateToFolder = (path: string) => {
    this.currentFolderPath = path;
  };

  selectFile = (file: File) => {
    this.router.transitionTo('library.folders.file', file.id!);
  };

  selectFolder = (folder: Folder) => {
    this.currentFolderPath = folder.id!;
  };

  onFileUploaded = (file: File) => {
    this.showUploader = false;
    this.router.transitionTo('library.folders.file', file.id!);
  };

  toggleUploader = () => {
    this.showUploader = !this.showUploader;
  };

  <template>
    <div>
      <Heading
        @text="Private Files"
        @secondary="Files stored securely for this client. These can be embedded in pages."
      >
        <button
          type="button"
          class="btn btn-primary"
          {{on "click" this.toggleUploader}}
        >
          <iconify-icon inline icon="ph:file-arrow-up-duotone" />
          {{if this.showUploader "Cancel Upload" "Upload File"}}
        </button>
      </Heading>

      {{#if this.showUploader}}
        <div class="card mb-4">
          <div class="card-body">
            <FileUploader
              @parentFolderId={{this.currentFolderPath}}
              @onFileUploaded={{this.onFileUploaded}}
            />
          </div>
        </div>
      {{/if}}

      <FileBrowser
        @path={{this.currentFolderPath}}
        @navigateToFolder={{this.navigateToFolder}}
        @selectFile={{this.selectFile}}
        @selectFolder={{this.selectFolder}}
      />
    </div>
  </template>
}
